import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	filterButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipMessageBeforeShortcut: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterButton: {
		id: 'filter-refinement.filter-popup.filter-button',
		defaultMessage: 'Filter',
		description:
			'Label shown for the "Filter" button which opens a popup displaying a list of filters that the user can apply to refine a list of Jira issues',
	},
	tooltipMessage: {
		id: 'filter-refinement.filter-popup.tooltip-message',
		defaultMessage: 'Filter <inline>Shift</inline> + <inline>F</inline>',
		description:
			'Tooltip message shown when hovering over the filter button, indicating the keyboard shortcut Shift + F',
	},
	tooltipMessageBeforeShortcut: {
		id: 'filter-refinement.filter-popup.tooltip-message-before-shortcut',
		defaultMessage: 'Filter',
		description:
			'Tooltip message shown when hovering over the filter button. It will be displayed before the keyboard shortcut.',
	},
});
export default messages;
